export default (function (nodeA, nodeB) {
    var rectA = nodeA.getBoundingClientRect();
    var rectB = nodeB.getBoundingClientRect();
    return rectA.top + rectA.height / 2 < rectB.top + rectB.height / 2;
});
